import React, { useState } from 'react';
import useEventListener from '../../utils/useEventListener';
import ConnectedTableOfContents from './ConnectedTableOfContents';
import TableOfContents from './TableOfContents';
import { usePostTOC } from '../PostTOCContext';

interface PostTOCStickyProps {
  postId: string;
}

const PostTOCSticky = ({ postId }: PostTOCStickyProps) => {
  const [container, setContainer] = useState<HTMLElement | null>(null);
  const { isTOCOpen } = usePostTOC();
  useEventListener(container, 'scroll', () => {
    container?.classList.toggle(
      'post-toc-sticky-content-scrolled',
      container.scrollTop > 0,
    );
  });

  if (!isTOCOpen) {
    return null;
  }

  return (
    <ConnectedTableOfContents postId={postId}>
      {(tocProps) =>
        tocProps.headers.length > 0 && (
          <nav className="post-toc-sticky">
            <h4 className="post-toc-title">Table of Contents</h4>
            <div ref={setContainer} className="post-toc-sticky-content">
              <TableOfContents {...tocProps} />
            </div>
          </nav>
        )
      }
    </ConnectedTableOfContents>
  );
};

export default PostTOCSticky;
